package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.showContentInOnePage
import org.hs_soft.runmynesto.domain.model.general.TableColumn
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.MenuCardEnum
import org.hs_soft.runmynesto.domain.model.home.options.menu_card_import.menu_card_model.MenuCardModel
import org.hs_soft.runmynesto.domain.model.home.options.menu_card_import.menu_card_model.MenuProductItemModel
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.ingeredient_list.Ingredients
import org.hs_soft.runmynesto.domain.model.home.template.product_categories.TemplateCategoryModel
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Text


@Composable
fun UploadMenuCard(
    modifier: Modifier = Modifier,
    windowSizeMode: WindowSizeModeEnum,
    onCancelImportMenuCardClick: () -> Unit,
    onImportClick: (MenuCardModel, List<Ingredients>?) -> Unit,
    menuCard: MenuCardModel,
    categories: MutableList<TemplateCategoryModel>,
    onMenuProductItemValueChange: (MenuCardModel, Int, String, dynamic) -> Unit,
    updateTemplateCategoryList: (MutableList<TemplateCategoryModel>, MenuCardModel) -> Unit
) {
    val menuItems = remember { mutableStateOf(menuCard.items) }

    LaunchedEffect(menuCard.items) {
        menuItems.value = menuCard.items
        updateTemplateCategoryList(categories, menuCard)
    }

    Column(
        modifier = modifier
            .fillMaxWidth()
            .fillMaxHeight()
            .styleModifier {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
            }
    ) {
        key(menuItems.value) {
            val (columns, tableData) = setMenuCardTableInfo(
                menuItems = menuItems.value,
                menuCard = menuCard,
                onMenuProductItemValueChange = onMenuProductItemValueChange,
                categories = categories
            )

            CustomTable(
                columns = columns,
                data = tableData,
                modifier = Modifier
                    .showContentInOnePage()
                ,
                showRefreshButton = false,
                onRowClick = {id,_->

                },
                isCustom = true
            )
        }
    }
}

private fun setMenuCardTableInfo(
    menuItems: List<MenuProductItemModel>,
    menuCard: MenuCardModel,
    onMenuProductItemValueChange: (MenuCardModel, Int, String, String) -> Unit,
    categories: MutableList<TemplateCategoryModel>
): Pair<List<TableColumn>, List<Map<String, Any?>>?> {
    val columns = MenuCardEnum.entries.map { header ->
        TableColumn(
            header = header.title,
            key = header.key,
            isNumeric = when (header) {
                MenuCardEnum.Price, MenuCardEnum.Weight,
                MenuCardEnum.ProductNumber -> true
                else -> false
            },
            customContent = when (header) {
                MenuCardEnum.Selected, MenuCardEnum.Alcoholic, MenuCardEnum.Vegan,
                MenuCardEnum.Vegetarian, MenuCardEnum.Kuchen, MenuCardEnum.Buffet -> { row ->
                    val id = row["id"]?.toString()?.toIntOrNull() ?: 0
                    val isChecked = row[header.key]?.toString()?.toBoolean() ?: false
                    {
                        CheckboxComponent(
                            title = "",
                            checkStatus = isChecked,
                            onUnChecked = {
                                onMenuProductItemValueChange(
                                    menuCard,
                                    id,
                                    header.title,
                                    false.toString()
                                )
                            },
                            onChecked = {
                                onMenuProductItemValueChange(
                                    menuCard,
                                    id,
                                    header.title,
                                    true.toString()
                                )
                            },

                        )


                    }
                }
                MenuCardEnum.Category -> { row ->
                    {
                        val id = row["id"]?.toString()?.toIntOrNull() ?: 0
                        DropDownItem(
                            modifier = Modifier,
                            options = categories,
                            label = "",
                            id = "category-input-${row[header.key]}:${row["id"]}",
                            itemWidth = Dimen.semiLargeEditTextWidth,
                            isFixed = true,
                            selectedItem = categories.find {
                                it.name?.lowercase() == row[header.key]?.toString()?.lowercase()
                            },
                            content = {
                                if (it is TemplateCategoryModel) {
                                    SpanText(
                                        text = it.name ?: "",
                                        modifier = Modifier
                                            .fontSize( FontSizes.mediumFontSize)
                                            .color( Theme.TextPrimary.rgb)
                                            .fontWeight(FontWeight.Normal)
                                            .fontFamily(FontFamily.Jakarta)
                                    )
                                }
                            },
                            onOptionClick = { newValue ->
                                onMenuProductItemValueChange(
                                    menuCard,
                                    id,
                                    header.title,
                                    (newValue as? TemplateCategoryModel)?.name ?: (row[header.key]?.toString() ?: "")
                                )
                            },
                        )
                    }
                }
                else -> { row ->
                    val id = row["id"]?.toString()?.toIntOrNull() ?: 0
                    val value = row[header.key]?.toString() ?: ""
                    {
                        CustomTextArea(
                            height = Dimen.mediumTableItemHeight,
                            label = "",
                            value =value ,
                            onFocusOut = {

                            },
                        ) { newValue ->
                            onMenuProductItemValueChange(
                                menuCard,
                                id,
                                header.title,
                                newValue
                            )
                        }
                    }
                }
            },
            width = when (header) {
                MenuCardEnum.Selected,
                MenuCardEnum.Alcoholic,
                MenuCardEnum.Vegan,
                MenuCardEnum.Vegetarian,
                MenuCardEnum.Name,
                MenuCardEnum.Description,
                MenuCardEnum.Allergens,
                MenuCardEnum.TurnoverGroup,
                MenuCardEnum.Kuchen,
                MenuCardEnum.Buffet,
                MenuCardEnum.Price, MenuCardEnum.Weight, MenuCardEnum.ProductNumber -> Dimen.smallEditTextWidth.value.toInt()
                MenuCardEnum.Category,
                MenuCardEnum.Ingredients -> Dimen.semiNormalEditTextWidth.value.toInt()
            }
        )
    }

    val tableData = menuItems.mapIndexed { index, item ->
        val allergensString = item.allergens?.joinToString(", ") ?: ""

        mapOf(
            "id" to index,
            MenuCardEnum.Selected.key to (item.selected ?: false),
            MenuCardEnum.Name.key to (item.name ?: ""),
            MenuCardEnum.Description.key to (item.description ?: ""),
            MenuCardEnum.Price.key to (item.price ?: ""),
            MenuCardEnum.Weight.key to (item.weight ?: ""),
            MenuCardEnum.Allergens.key to allergensString,
            MenuCardEnum.Category.key to (item.category ?: ""),
            MenuCardEnum.TurnoverGroup.key to (item.turnoverGroup ?: ""),
            //MenuCardEnum.Template.key to (item.template ?: ""),
            MenuCardEnum.Ingredients.key to (item.ingredients ?: ""),
            MenuCardEnum.ProductNumber.key to (item.productNumber ?: ""),
            MenuCardEnum.Kuchen.key to (item.kuchen ?: false),
            MenuCardEnum.Buffet.key to (item.buffet ?: false),
            MenuCardEnum.Alcoholic.key to (item.alcoholic ?: false),
            MenuCardEnum.Vegan.key to (item.vegan ?: false),
            MenuCardEnum.Vegetarian.key to (item.vegetarian ?: false)
        )
    }

    return Pair(columns, tableData)
}

